import {
    GET_VIDEOS,
    GET_VIDEOS_SUCCESS,
    GET_VIDEOS_FAILURE,
    UPDATE_VIDEOS_STATUS,
    UPDATE_VIDEOS_STATUS_SUCCESS,
    UPDATE_VIDEOS_STATUS_FAILURE,
    DELETE_VIDEOS,
    DELETE_VIDEOS_SUCCESS,
    DELETE_VIDEOS_FAILURE,
    ADD_VIDEO,
    ADD_VIDEO_SUCCESS,
    ADD_VIDEO_FAILURE,
    EDIT_VIDEO,
    EDIT_VIDEO_SUCCESS,
    EDIT_VIDEO_FAILURE,
    UPDATE_VIDEO_ORDER_STATUS,
    UPDATE_VIDEO_ORDER_STATUS_SUCCESS,
    UPDATE_VIDEO_ORDER_STATUS_FAILURE
} from "../Constants";

export const GetVideos = (payload) => ({
    type: GET_VIDEOS,
    payload
});

export const GetVideosSuccess = (payload) => ({
    type: GET_VIDEOS_SUCCESS,
    payload
});

export const GetVideosFailure = (payload) => ({
    type: GET_VIDEOS_FAILURE,
    payload
});

export const UpdateVideoOrderStatus = (payload) => ({
    type: UPDATE_VIDEO_ORDER_STATUS,
    payload
});

export const UpdateVideoOrderStatusSuccess = (payload) => ({
    type: UPDATE_VIDEO_ORDER_STATUS_SUCCESS,
    payload
});

export const UpdateVideoOrderStatusFailure = (payload) => ({
    type: UPDATE_VIDEO_ORDER_STATUS_FAILURE,
    payload
});

export const UpdateVideosStatus = (payload) => ({
    type: UPDATE_VIDEOS_STATUS,
    payload
});

export const UpdateVideosStatusSuccess = (payload) => ({
    type: UPDATE_VIDEOS_STATUS_SUCCESS,
    payload
});

export const UpdateVideosStatusFailure = (payload) => ({
    type: UPDATE_VIDEOS_STATUS_FAILURE,
    payload
});

export const DeleteVideos = (payload) => ({
    type: DELETE_VIDEOS,
    payload
});

export const DeleteVideosSuccess = (payload) => ({
    type: DELETE_VIDEOS_SUCCESS,
    payload
});

export const DeleteVideosFailure = (payload) => ({
    type: DELETE_VIDEOS_FAILURE,
    payload
});

export const AddVideo = (payload) => ({
    type: ADD_VIDEO,
    payload
});

export const AddVideoSuccess = (payload) => ({
    type: ADD_VIDEO_SUCCESS,
    payload
});

export const AddVideoFailure = (payload) => ({
    type: ADD_VIDEO_FAILURE,
    payload
});

export const EditVideo = (payload) => ({
    type: EDIT_VIDEO,
    payload
});

export const EditVideoSuccess = (payload) => ({
    type: EDIT_VIDEO_SUCCESS,
    payload
});

export const EditVideoFailure = (payload) => ({
    type: EDIT_VIDEO_FAILURE,
    payload
});